import React, { useEffect } from 'react';
import { UnAuthorised } from './UnAuthorised';
import { MainLayoutProps } from '../../Api/Interface/layout.interface';
import { useAppDispatch } from '../../Store/hooks';
import { useGetUserQuery } from '../../Api/attoDeskApi';
import { setEnableAuth } from '../../Store/Auth/AuthSlice';

/**
 * Main layout which will load the content with the children
 * @param children - Component
 */
const MainLayout = ({ children }: MainLayoutProps) => {
  const dispatch = useAppDispatch();
  // Skip the user fetch on TRULY public pages. Print-sheet looks like
  // a portal (no chrome) but still requires admin auth, so we keep
  // fetching the user for that one.
  const path = window.location.pathname;
  const isPortalRoute =
    path.includes('/restaurant-portal') ||
    path.startsWith('/player/') ||
    path.startsWith('/p/') ||
    path.startsWith('/installer') ||
    path.startsWith('/download/');
  const { data, isError } = useGetUserQuery(undefined, { skip: isPortalRoute });
  useEffect(() => {
    if (data?.code === 200) {
      dispatch(setEnableAuth());
    }
  }, [data?.code, dispatch]);
  return (
    <>
    {children}
      {/* {!data && <>{children}</>}
      {!data && <UnAuthorised data-testid="unautorised-fallback" />} */}
    </>
  );
};

export default React.memo(MainLayout);
